/**
 * toastProvider
 *
 * @author Dec Norton <decnorton@gmail.com>
 */
import { nl2br } from '@app/filters/nl2br-filter';

export function toastProvider() {
    this.$get = $get;

    $get.$inject = ['$mdToast', '$mdUtil'];

    function $get($mdToast, $mdUtil) {
        return new class {
            constructor() {
                this.toast = this.toast.bind(this);
                this.successToast = this.successToast.bind(this);
                this.notificationToast = this.notificationToast.bind(this)
            }

            hide() {
                $mdToast.hide();
            }

            toast(message, hideDelay = 5000) {
                return $mdToast.show(
                    $mdToast
                        .simple()
                        .action('Dismiss')
                        .textContent(message)
                        .hideDelay(hideDelay)
                        .position('bottom right'),
                );
            }

            progressToast(message = '') {
                return new function() {
                    const toast = $mdToast.show({
                        hideDelay: 0,
                        position: 'bottom right',
                        controller: ProgressToastController,
                        template: `
                            <md-toast class="app-toast--progress">
                                <span flex>{{ message }}</span>

                                <md-progress-circular class="md-progress-circular--white"
                                                      md-diameter="24"
                                                      md-mode="indeterminate">
                                </md-progress-circular>
                            </md-toast>
                        `,
                    });

                    let controllerInstance;

                    ProgressToastController.$inject = ['$scope'];

                    function ProgressToastController($scope) {
                        controllerInstance = this;

                        $scope.message = message;

                        this._updateMessage = function _updateMessage(message) {
                            $scope.message = message;
                        };
                    }

                    this.hide = function hide() {
                        return $mdToast.hide();
                    };

                    this.updateMessage = function updateMessage(message) {
                        $mdUtil.nextTick(() => {
                            if (controllerInstance) {
                                controllerInstance._updateMessage(message);
                            }
                        });
                    };

                    this.toast = toast;
                }();
            }

            successToast(message) {
                return this.toast(message);
            }

            errorToast(message, hideDelay = 5000) {
                return $mdToast.show({
                    hideDelay,
                    position: 'bottom right',
                    controller: ErrorToastController,
                    controllerAs: 'toast',
                    // language=HTML
                    template: `
                        <md-toast class="app-toast-error">
                            <div class="md-toast-content">
                                <md-icon>error</md-icon>

                                ${nl2br(message)}

                                <md-button class="md-action" ng-click="toast.resolve()">
                                    Dismiss
                                </md-button>
                            </div>
                        </md-toast>
                    `,
                });
            }

            notificationToast(message, subMessage = null, callback, hideDelay = 10000) {
                return new function () {
                    const toast = $mdToast.show({
                        hideDelay,
                        position: 'bottom right',
                        controller: NotificationToastController,
                        controllerAs: 'toast',
                        template: `
                            <md-toast class="app-toast--notification">
                                <div class="md-toast-content">
                                    <div class="icon-container">
                                        <md-icon class="size-48">check_circle</md-icon>
                                    </div>

                                    <div class="message-container">
                                        ${nl2br(message)}

                                        <small ng-if="subMessage">
                                            ${nl2br(subMessage)}
                                        </small>
                                    </div>

                                    <md-button ng-click="callback()" class="md-action md-icon-button">
                                        <md-icon class="size-32">chevron_right</md-icon>
                                    </md-button>
                                </div>
                            </md-toast>
                        `,
                    });

                    NotificationToastController.$inject = ['$scope'];

                    function NotificationToastController($scope) {
                        $scope.message = message;
                        $scope.subMessage = subMessage;
                        $scope.callback = callback;
                    }

                    this.toast = toast;
                }
            }
        }();
    }
}

ErrorToastController.$inject = ['$mdToast'];

function ErrorToastController($mdToast) {
    this.$onInit = function() {
        this.resolve = () => $mdToast.hide();
    };
}

